// app-uppercase.directive.ts
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[uppercase]' })
export class UppercaseDirective {
  private composing = false;
  constructor(private el: ElementRef<HTMLInputElement>, private ng: NgControl) { }

  @HostListener('compositionstart') onCompStart() { this.composing = true; }
  @HostListener('compositionend') onCompEnd() { this.composing = false; this.forceUpper(); }
  @HostListener('input') onInput() { if (!this.composing) this.forceUpper(); }

  private forceUpper() {
    const input = this.el.nativeElement;
    const { selectionStart, selectionEnd, value } = input;
    const upper = value.toUpperCase();
    if (value !== upper) {
      input.value = upper;                              // update view
      this.ng?.control?.setValue(upper, { emitEvent: false }); // update model, no loop
      input.setSelectionRange(selectionStart, selectionEnd);   // keep caret
    }
  }
}
